import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";
import React, { useContext, useEffect, useReducer, useState } from "react";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import AnnouncementDisplayModal from "../AnnouncementDisplayModal";

import {
  Avatar,
  Badge,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
  Chip,
} from "@material-ui/core";
import { isArray } from "lodash";
import moment from "moment";
import api from "../../services/api";
import NotificationsIcon from '@material-ui/icons/Notifications';
// import { SocketContext } from "../../context/Socket/SocketContext";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    maxHeight: 400,
    maxWidth: 450,
    padding: 0,
    overflowY: "scroll",
    overflowX: "hidden",
    borderRadius: 12,
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    ...theme.scrollbarStyles,
  },
  
  // 🎨 ANIMAÇÕES DO BADGE INTELIGENTE
  badgeAnimated: {
    animation: '$pulseGlow 2s ease-in-out infinite',
  },
  
  '@keyframes pulseGlow': {
    '0%': {
      transform: 'scale(1)',
      opacity: 1,
      boxShadow: '0 0 5px rgba(255, 152, 0, 0.3)',
    },
    '50%': {
      transform: 'scale(1.1)',
      opacity: 0.8,
      boxShadow: '0 0 20px rgba(255, 152, 0, 0.8), 0 0 30px rgba(255, 152, 0, 0.6)',
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 1,
      boxShadow: '0 0 5px rgba(255, 152, 0, 0.3)',
    },
  },
  
  smartBadge: {
    backgroundColor: '#ff9800',
    color: 'white',
    fontWeight: 600,
    fontSize: '11px',
    minWidth: '18px',
    height: '18px',
    borderRadius: '9px',
    border: '2px solid white',
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
  },
  listItem: {
    padding: theme.spacing(2.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
    cursor: "pointer",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      paddingLeft: theme.spacing(3),
      "&::before": {
        opacity: 1,
      },
    },
    "&:last-child": {
      borderBottom: "none",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: 3,
      backgroundColor: theme.palette.primary.main,
      opacity: 0,
      transition: "opacity 0.2s ease",
    },
  },
  listItemContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.2),
    width: "100%",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
  },
  title: {
    fontWeight: 600,
    fontSize: "0.95rem",
    color: theme.palette.text.primary,
    lineHeight: 1.4,
    flex: 1,
    letterSpacing: "-0.01em",
  },
  chipContainer: {
    display: "flex",
    gap: theme.spacing(0.75),
    flexShrink: 0,
    alignItems: "center",
  },
  priorityChip: {
    height: 22,
    fontSize: "0.7rem",
    fontWeight: 600,
    borderRadius: 11,
    letterSpacing: "0.02em",
    textTransform: "uppercase",
  },
  categoryChip: {
    height: 22,
    fontSize: "0.7rem",
    fontWeight: 500,
    borderRadius: 11,
    letterSpacing: "0.01em",
  },
  
  // 🎯 ESTILOS PARA STATUS DE LEITURA
  readStatusIndicator: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    marginRight: theme.spacing(1),
    flexShrink: 0,
  },
  
  unreadIndicator: {
    backgroundColor: theme.palette.primary.main,
    boxShadow: `0 0 4px ${theme.palette.primary.main}40`,
  },
  
  pendingIndicator: {
    backgroundColor: theme.palette.warning.main,
    boxShadow: `0 0 4px ${theme.palette.warning.main}40`,
  },
  
  readIndicator: {
    backgroundColor: theme.palette.success.main,
    opacity: 0.6,
  },
  
  listItemWithStatus: {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: 3,
      backgroundColor: "transparent",
    },
  },
  
  unreadItem: {
    "&::before": {
      backgroundColor: theme.palette.primary.main,
    },
    backgroundColor: `${theme.palette.primary.main}08`,
  },
  
  pendingItem: {
    "&::before": {
      backgroundColor: theme.palette.warning.main,
    },
    backgroundColor: `${theme.palette.warning.main}08`,
  },
  priorityHigh: {
    backgroundColor: "#e53e3e",
    color: "white",
    boxShadow: "0 2px 8px rgba(229, 62, 62, 0.3)",
  },
  priorityMedium: {
    backgroundColor: "#f56500",
    color: "white",
    boxShadow: "0 2px 8px rgba(245, 101, 0, 0.3)",
  },
  priorityLow: {
    backgroundColor: "#38a169",
    color: "white",
    boxShadow: "0 2px 8px rgba(56, 161, 105, 0.3)",
  },
  preview: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginTop: theme.spacing(0.5),
  },
  dateText: {
    fontSize: "0.75rem",
    color: theme.palette.text.disabled,
    fontWeight: 500,
    letterSpacing: "0.02em",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    "&::before": {
      content: '"•"',
      fontSize: "0.6rem",
      opacity: 0.6,
    },
  },
  emptyState: {
    padding: theme.spacing(4),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
    "&::before": {
      content: '"📢"',
      fontSize: "2rem",
      opacity: 0.5,
    },
  },
}));

const reducer = (state, action) => {
  if (action.type === "LOAD_ANNOUNCEMENTS") {
    const announcements = action.payload;
    const newAnnouncements = [];

    if (isArray(announcements)) {
      announcements.forEach((announcement) => {
        const announcementIndex = state.findIndex(
          (u) => u.id === announcement.id
        );
        if (announcementIndex !== -1) {
          state[announcementIndex] = announcement;
        } else {
          newAnnouncements.push(announcement);
        }
      });
    }

    return [...state, ...newAnnouncements];
  }

  if (action.type === "UPDATE_ANNOUNCEMENTS") {
    const announcement = action.payload;
    const announcementIndex = state.findIndex((u) => u.id === announcement.id);

    if (announcementIndex !== -1) {
      state[announcementIndex] = announcement;
      return [...state];
    } else {
      return [announcement, ...state];
    }
  }

  if (action.type === "DELETE_ANNOUNCEMENT") {
    const announcementId = action.payload;

    const announcementIndex = state.findIndex((u) => u.id === announcementId);
    if (announcementIndex !== -1) {
      state.splice(announcementIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

// Função para validar se o anúncio deve ser exibido para o usuário atual
const shouldShowAnnouncementForUser = (announcement, user) => {
  // 1. Verificar se está ativo
  if (!announcement.status) return false;
  
  // 2. Verificar expiração
  if (announcement.expiresAt && new Date(announcement.expiresAt) < new Date()) {
    return false;
  }
  
  // 3. Verificar empresa destinatária
  if (announcement.targetCompanyId !== null && announcement.targetCompanyId !== user.companyId) {
    return false;
  }
  
  // 4. Verificar público-alvo
  const targetAudienceMap = {
    super: ["all", "super"],
    admin: ["all", "admins"],
    user: ["all", "users"]
  };
  
  const allowedAudiences = targetAudienceMap[user.profile] || ["all", "users"];
  if (!allowedAudiences.includes(announcement.targetAudience)) {
    return false;
  }
  
  return true;
};

// Funções auxiliares para renderização
const getPriorityInfo = (priority) => {
  switch (priority) {
    case 1:
      return { label: "Alta", className: "priorityHigh" };
    case 2:
      return { label: "Média", className: "priorityMedium" };
    case 3:
      return { label: "Baixa", className: "priorityLow" };
    default:
      return { label: "Normal", className: "priorityMedium" };
  }
};

const getCategoryInfo = (category) => {
  const categories = {
    'info': { icon: 'ℹ️', text: 'Info', color: '#3182ce' },
    'promo': { icon: '🎉', text: 'Promo', color: '#f56500' },
    'alert': { icon: '⚠️', text: 'Alerta', color: '#e53e3e' },
    'maintenance': { icon: '🔧', text: 'Manutenção', color: '#718096' },
    'feature': { icon: '✨', text: 'Novidade', color: '#805ad5' },
    'billing': { icon: '💰', text: 'Cobrança', color: '#38a169' },
    'update': { icon: '🔄', text: 'Update', color: '#00a3c4' },
    'security': { icon: '🔒', text: 'Segurança', color: '#744210' },
    'event': { icon: '📅', text: 'Evento', color: '#d69e2e' },
    'general': { icon: '📢', text: 'Geral', color: '#4a5568' }
  };
  return categories[category] || categories['general'];
};

// 🎯 FUNÇÃO PARA DETERMINAR STATUS DE LEITURA
const getReadStatus = (item) => {
  if (!item.viewStatus) {
    return { type: "unread", label: "Não lido", className: "unreadIndicator" };
  }
  
  // CORREÇÃO: Para anúncios que REQUEREM confirmação
  if (item.requiresAcknowledge) {
    if (item.viewStatus.acknowledged) {
      return { type: "read", label: "Lido e confirmado", className: "readIndicator" };
    }
    if (item.viewStatus.viewed) {
      return { type: "pending", label: "Aguardando confirmação", className: "pendingIndicator" };
    }
    return { type: "unread", label: "Não lido", className: "unreadIndicator" };
  }
  
  // Para anúncios que NÃO requerem confirmação
  if (item.viewStatus.viewed) {
    return { type: "read", label: "Visualizado", className: "readIndicator" };
  }
  
  return { type: "unread", label: "Não lido", className: "unreadIndicator" };
};

// 🎯 FUNÇÃO PARA DETERMINAR CLASSE DO LISTITEM
const getListItemClassName = (item, classes) => {
  const readStatus = getReadStatus(item);
  let className = `${classes.listItem} ${classes.listItemWithStatus}`;
  
  if (readStatus.type === "unread") {
    className += ` ${classes.unreadItem}`;
  } else if (readStatus.type === "pending") {
    className += ` ${classes.pendingItem}`;
  }
  
  return className;
};

const truncateText = (text, maxLength = 80) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + '...';
};

export default function AnnouncementsPopover() {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [searchParam] = useState("");
  const [announcements, dispatch] = useReducer(reducer, []);
  const [invisible, setInvisible] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
  
  // 🎯 SISTEMA DE BADGE INTELIGENTE
  const [unreadCount, setUnreadCount] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationTimer, setAnimationTimer] = useState(null);
  
  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);
  
  // 🎯 FUNÇÃO PARA CALCULAR CONTAGEM INTELIGENTE
  const calculateUnreadCount = async () => {
    try {
      const { data } = await api.get("/announcement-views/unread-count");
      const count = data.count || 0;
      
      setUnreadCount(count);
      setInvisible(count === 0);
      
      return count;
    } catch (error) {
      setUnreadCount(0);
      setInvisible(true);
      return 0;
    }
  };

  // 🎯 FUNÇÃO PARA FORMATAR BADGE (1-9 números, 10+ = "9+")
  const formatBadgeCount = (count) => {
    if (count === 0) return "";
    if (count <= 9) return count.toString();
    return "9+";
  };

  // 🎯 FUNÇÃO PARA INICIAR ANIMAÇÃO POR 5 MINUTOS
  const startBadgeAnimation = () => {
    
    // Limpar timer anterior se existir
    if (animationTimer) {
      clearTimeout(animationTimer);
    }
    
    setIsAnimating(true);
    
    // Parar animação após 5 minutos (300000ms)
    const timer = setTimeout(() => {
      console.log("🎨 [BADGE] Parando animação após 5 minutos");
      setIsAnimating(false);
    }, 300000);
    
    setAnimationTimer(timer);
  };

  // 🎯 PARAR ANIMAÇÃO QUANDO POPOVER É ABERTO
  const stopBadgeAnimation = () => {
    if (animationTimer) {
      clearTimeout(animationTimer);
      setAnimationTimer(null);
    }
    setIsAnimating(false);
    console.log("🎨 [BADGE] Animação parada (popover aberto)");
  };

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchAnnouncements();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);

  // useEffect separado para quando o user é carregado
  useEffect(() => {
    if (user?.id && user?.companyId) {
      setLoading(true);
      const delayDebounceFn = setTimeout(() => {
        fetchAnnouncements();
        calculateUnreadCount(); // 🎯 Calcular contagem inicial
      }, 100);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [user?.id, user?.companyId]);

  useEffect(() => {
    if (user.companyId) {
      const companyId = user.companyId;
      //    const socket = socketManager.GetSocket();

      const onCompanyAnnouncementNotification = (data) => {
        if (data.action === "update" || data.action === "create") {
          // ✅ VALIDAR se o anúncio é válido para este usuário
          const announcement = data.record;
          
          if (shouldShowAnnouncementForUser(announcement, user)) {
            dispatch({ type: "UPDATE_ANNOUNCEMENTS", payload: announcement });
            setInvisible(false);
            
            // 🎯 ATUALIZAR CONTAGEM E INICIAR ANIMAÇÃO
            calculateUnreadCount().then(count => {
              if (count > 0 && data.action === "create") {
                startBadgeAnimation();
              }
            });
          }
        }
        if (data.action === "delete") {
          dispatch({ type: "DELETE_ANNOUNCEMENT", payload: +data.id });
          // 🎯 RECALCULAR CONTAGEM APÓS EXCLUSÃO
          calculateUnreadCount();
        }
      };

      // 🎯 ESCUTAR EVENTOS ESPECÍFICOS DE CONFIRMAÇÃO E DISPENSA
      const onAnnouncementAcknowledged = (data) => {
        // Só atualizar se for relacionado ao usuário atual
        if (data.userId === user.id) {
          setTimeout(() => {
            fetchAnnouncements();
            calculateUnreadCount();
          }, 500);
        }
      };

      const onAnnouncementDismissed = (data) => {
        // Só atualizar se for relacionado ao usuário atual
        if (data.userId === user.id) {
          setTimeout(() => {
            fetchAnnouncements();
            calculateUnreadCount();
          }, 500);
        }
      };

      const onAnnouncementViewUpdated = (data) => {
        console.log("🔔 [SOCKET] announcement-view-updated recebido:", data);
        // ✅ Atualizar lista imediatamente quando houver mudança de visualização
        // Só atualizar se for relacionado ao usuário atual
        if (data.userId === user.id) {
          fetchAnnouncements();
          calculateUnreadCount();
        }
      };
      
      socket.on(`company-announcement-notification`, onCompanyAnnouncementNotification);
      socket.on("announcement-acknowledged", onAnnouncementAcknowledged);
      socket.on("announcement-dismissed", onAnnouncementDismissed);
      socket.on("announcement-view-updated", onAnnouncementViewUpdated);

      return () => {
        socket.off(`company-announcement-notification`, onCompanyAnnouncementNotification);
        socket.off("announcement-acknowledged", onAnnouncementAcknowledged);
        socket.off("announcement-dismissed", onAnnouncementDismissed);
        socket.off("announcement-view-updated", onAnnouncementViewUpdated);
      };
    }
  }, [user]);

  const fetchAnnouncements = async () => {
    if (!user?.id || !user?.companyId) {
      setLoading(false);
      return;
    }

    try {
      const { data } = await api.get("/announcement-views/valid", {
        params: { 
          onlyModal: false, // Buscar anúncios do popover (não apenas modal)
          ignoreAcknowledgments: true // Ignorar confirmações para mostrar no popover
        },
      });
      dispatch({ type: "LOAD_ANNOUNCEMENTS", payload: data });
      setHasMore(false); // GetValidAnnouncementsService não usa pagination
      setLoading(false);
    } catch (err) {
      console.error("❌ [DEBUG] Erro ao buscar anúncios:", err);
      toastError(err);
      setLoading(false);
    }
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setInvisible(true);
    stopBadgeAnimation(); // 🎯 Parar animação quando popover abre
  };

  const handleClose = () => {
    setAnchorEl(null);
    // 🎯 Recalcular contagem após fechar popover (usuário pode ter visualizado)
    setTimeout(() => {
      calculateUnreadCount();
    }, 500);
  };

  const handleShowAnnouncementModal = (record) => {
    setSelectedAnnouncement(record);
    setShowAnnouncementModal(true);
    setAnchorEl(null);
  };

  const handleCloseAnnouncementModal = () => {
    setShowAnnouncementModal(false);
    setSelectedAnnouncement(null);
    // 🎯 FORÇA atualização imediata da lista após interação no modal
    console.log("🔄 [POPOVER] Modal fechado - atualizando lista imediatamente");
    fetchAnnouncements();
    calculateUnreadCount();
  };

  // 🎯 CLEANUP - Limpar timer ao desmontar componente
  useEffect(() => {
    return () => {
      if (animationTimer) {
        clearTimeout(animationTimer);
      }
    };
  }, [animationTimer]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <AnnouncementDisplayModal
        externalAnnouncements={selectedAnnouncement ? [selectedAnnouncement] : []}
        isExternal={true}
        onExternalClose={handleCloseAnnouncementModal}
      />
      <IconButton
        variant="contained"
        aria-describedby={id}
        onClick={handleClick}
        size="small"
        style={{ color: "white", marginRight: 0 }}
        className={isAnimating ? classes.badgeAnimated : ''}
      >
        <Badge
          color="secondary"
          badgeContent={formatBadgeCount(unreadCount)}
          invisible={invisible || unreadCount === 0}
          classes={{
            badge: classes.smartBadge
          }}
        >
          <NotificationsIcon style={{ width: "20px", height: "20px" }} />
        </Badge>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          style: {
            maxWidth: "90vw",
            overflow: "hidden",
          }
        }}
      >
        <Paper
          variant="outlined"
          onScroll={handleScroll}
          className={classes.mainPaper}
        >
          {/* Header com legenda dos indicadores */}
          <div style={{ 
            padding: "8px 16px", 
            borderBottom: "1px solid #e0e0e0", 
            backgroundColor: "#f5f5f5",
            fontSize: "0.75rem",
            color: "#666"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <div style={{ 
                  width: 6, 
                  height: 6, 
                  borderRadius: "50%", 
                  backgroundColor: "#1976d2" 
                }} />
                <span>Não lido</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <div style={{ 
                  width: 6, 
                  height: 6, 
                  borderRadius: "50%", 
                  backgroundColor: "#ff9800" 
                }} />
                <span>Aguardando confirmação</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <div style={{ 
                  width: 6, 
                  height: 6, 
                  borderRadius: "50%", 
                  backgroundColor: "#4caf50",
                  opacity: 0.6 
                }} />
                <span>Lido</span>
              </div>
            </div>
          </div>
          
          <List component="nav" style={{ padding: 0 }}>
            {isArray(announcements) &&
              announcements.map((item, key) => {
                const priorityInfo = getPriorityInfo(item.priority);
                const categoryInfo = getCategoryInfo(item.category);
                const readStatus = getReadStatus(item);
                
                return (
                  <ListItem
                    key={key}
                    className={getListItemClassName(item, classes)}
                    onClick={() => handleShowAnnouncementModal(item)}
                    disableGutters
                  >
                    <div className={classes.listItemContent}>
                      {/* Header com título, chips e indicador de status */}
                      <div className={classes.headerRow}>
                        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
                          {/* Indicador de status de leitura */}
                          <div 
                            className={`${classes.readStatusIndicator} ${classes[readStatus.className]}`}
                            title={readStatus.label}
                          />
                          <Typography className={classes.title}>
                            {item.title}
                          </Typography>
                        </div>
                        <div className={classes.chipContainer}>
                          <Chip
                            label={categoryInfo.text}
                            size="small"
                            className={classes.categoryChip}
                            style={{
                              backgroundColor: `${categoryInfo.color}20`,
                              color: categoryInfo.color,
                              border: `1px solid ${categoryInfo.color}40`,
                            }}
                          />
                          <Chip
                            label={priorityInfo.label}
                            size="small"
                            className={`${classes.priorityChip} ${classes[priorityInfo.className]}`}
                          />
                        </div>
                      </div>
                      
                      {/* Preview do conteúdo */}
                      <Typography className={classes.preview}>
                        {truncateText(item.text)}
                      </Typography>
                      
                      {/* Data */}
                      <Typography className={classes.dateText}>
                        {moment(item.createdAt).format("DD/MM/YYYY HH:mm")}
                      </Typography>
                    </div>
                  </ListItem>
                );
              })}
            {isArray(announcements) && announcements.length === 0 && (
              <div className={classes.emptyState}>
                <Typography>
                  {i18n.t("mainDrawer.appBar.notRegister")}
                </Typography>
              </div>
            )}
          </List>
        </Paper>
      </Popover>
    </div>
  );
}
